export default function () {
  jQuery(($) => {
    const locationSelector = Array.from(document.getElementsByClassName('location-select'));
    locationSelector.forEach((locationSelect) => {
      locationSelect.addEventListener('change', (event) => {
        const selectedTerm = Number(event.currentTarget.value);
        const currentModule = $(event.currentTarget).closest('.module-dealers');
        const locationGroups = $(currentModule).find('.term-group');
        if (selectedTerm) {
          if (locationGroups && locationGroups.length) {
            for (let i = 0; i < locationGroups.length; i += 1) {
              if ($(locationGroups[i]).data('term-id') !== selectedTerm) {
                $(locationGroups[i]).hide();
              } else {
                $(locationGroups[i]).show();
              }
            }
          }
        } else {
          $(locationGroups).show();
        }
      });
    });
  });
}
